export default __webpack_public_path__ + "static/media/i194jk.fc4e660a.webp";